import { getApiKey } from "../../utils/apiKey";
import { MenuItem, Select } from "@mui/material";
import axios from "axios";
import React, { Component } from "react";
import { apiCall_domain, apiCall_domainV2 } from "../api";
import Addressmodal from "./Addressmodal";

class Delivery extends Component {
  state = {
    deliveryTypes: null,
    addresses: null,
    customerInfo: null,
    showChangeAddressModal: false,
    times: null,
    hours: null,
  };
  async componentDidMount() {
    const config = {
      headers: {
        Authorization: getApiKey(),
        "content-type": "application/json",
      },
    };
    const splash = localStorage.getItem("splash")
      ? JSON.parse(localStorage.getItem("splash"))
      : null;
    let cityId;
    if (splash) {
      cityId = splash.customer_info.city.id;
      this.setState({ customerInfo: splash.customer_info });
    } else {
      await axios
        .get(`${apiCall_domain}/customer/splash`, config)
        .then((res) => {
          cityId = res.data.customer_info.city.id;
          localStorage.setItem("splash", JSON.stringify(res.data));
          this.setState({ customerInfo: res.data.customer_info });
        });
    }
    await axios
      .get(`${apiCall_domain}/customer/shipping_type/${cityId}`, config)
      .then((res) => {
        this.setState({ deliveryTypes: res.data });
      });
    await axios
      .get(`${apiCall_domain}/customer/user/addresses?is_order=1`, config)
      .then((res) => {
        this.setState({
          addresses: res.data.data,
        });
        this.props.methods.changeSelectedAddress(res.data.data[0] || null);
      });
    this.productTime();
  }
  manageChangeAddressModal = (state) => {
    this.setState({ showChangeAddressModal: state });
    const body = document.querySelector("body");
    if (state) {
      body.style.overflow = "hidden";
    } else {
      body.style.overflow = "auto";
    }
  };

  productTime = () => {
    const config = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    const product = this.props.data.productWithOutSerive.map((item) => item.id);
    axios
      .post(
        `${apiCall_domainV2}/customer/products/times`,
        { vendor_item_ids: product },
        {
          headers: config,
        },
      )
      .then((res) => {
        this.setState({ times: res.data });
      });
  };

  handleTimeChange = (e) => {
    this.setState({ hours: e.target.value.hours });
  };

  render() {
    const {
      selectedAddress,
      selectedDelivery,
      can_pay_cash,
      dTypes,
      selectedForeignCollect,
    } = this.props.data;
    const {
      changeSelectedAddress,
      changeDeliveryType,
      handleChangeSelectedForeignCollect,
    } = this.props.methods;
    return (
      <>
        <main className="Delivery">
          <span className="Title">آدرس منتخب شما</span>
          <div className="TitleAddress">
            {selectedAddress ? (
              <>
                <div>
                  <span>{selectedAddress.title}</span>
                </div>
                <div className="AddressContent">
                  <div className="Img">
                    <img src="/public/assets/icons/location1.svg" alt="pic" />
                  </div>
                  <span>{selectedAddress.address}</span>
                </div>
                <div className="AddressContent">
                  <div className="Img">
                    <img src="/public/assets/icons/phone1.svg" alt="pic" />
                  </div>
                  <span>{selectedAddress.address_phone}</span>
                </div>
                {selectedAddress.postal_code ? (
                  <div className="AddressContent">
                    <div className="Img">
                      <img
                        src="/public/assets/icons/sms-tracking.svg"
                        alt="pic"
                      />
                    </div>
                    <span>{selectedAddress.postal_code}</span>
                  </div>
                ) : null}
                <div className="AddressContent">
                  <div className="Img">
                    <img src="/public/assets/icons/frame.svg" alt="pic" />
                  </div>
                  <span>
                    {this.state.customerInfo
                      ? this.state.customerInfo.name
                      : null}
                  </span>
                </div>
              </>
            ) : (
              "آدرس خود را انتخاب کنید"
            )}
          </div>
          <p
            className="Edit"
            onClick={() => {
              this.manageChangeAddressModal(true);
            }}
          >
            تغییر یا ویرایش آدرس
          </p>
          <span className="ReceiptTime">شیوه ارسال</span>
          <p className="SendingMethod">
            شیوه ارسال خود را برای محصولات بدون نصب انتخاب کنید
          </p>
          <div className="SendingMethods">
            {this.state.deliveryTypes
              ?.filter((f) => f.id !== 0)
              ?.map((type) => (
                <div
                  className={`SendingMethod ${
                    selectedDelivery === type.id ? "selected" : ""
                  }`}
                >
                  <div
                    className="Head"
                    disabled={type.d === 1 && can_pay_cash === 0 ? true : false}
                    onClick={() => {
                      changeDeliveryType(type.id);
                    }}
                  >
                    <div className="Img">
                      <img
                        src="/public/assets/icons/truck-fast.svg"
                        alt="pic"
                      />
                    </div>
                    <span>{type.name}</span>
                    {selectedDelivery == type.id ? (
                      <div className="tick">
                        <img src="/public/assets/icons/tickk.svg" alt="pic" />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <p>{type.text}</p>
                </div>
              ))}
          </div>
          {selectedDelivery === 1 ? (
            <div className="SendingMethods">
              {dTypes?.map((type) => (
                <div
                  className={`SendingMethod ${
                    selectedForeignCollect === type.id ? "selected" : ""
                  }`}
                >
                  <div
                    className="Head"
                    onClick={() => {
                      handleChangeSelectedForeignCollect(type.id);
                    }}
                  >
                    <div className="Img">
                      <img
                        src="/public/assets/icons/truck-fast.svg"
                        alt="pic"
                      />
                    </div>
                    <span>{type.title}</span>
                    <span className="hint">{type.description}</span>

                    {selectedForeignCollect === type.id ? (
                      <div className="tick">
                        <img src="/public/assets/icons/tickk.svg" alt="pic" />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : null}

          {this.state.showChangeAddressModal ? (
            <Addressmodal
              addresses={this.state.addresses}
              setSelectedAddress={changeSelectedAddress}
              hidePopup={() => {
                this.manageChangeAddressModal(false);
              }}
            />
          ) : null}
        </main>
      </>
    );
  }
}
export default Delivery;
